import sidePanelCardFactory from '../components/SidepanelModalCard/cardFactory';
import markerCardFactory from '../components/MarkerModalCard/cardFactory';
import { lazyLoadComponent } from '../utils';

class ModalContentManager {
	constructor(modal) {
		this.modal = modal;
		this.cache = {};
		this.currentContent = null;
	}

	mountComponent(container) {
		this.modal.mount(container);
	}

	async contentFactory(type, key, extra) {
		if (type === 'sidepanel') {
			switch (key) {
			case 'howToAttribute':
				return new (await lazyLoadComponent('Modal', 'AttributionModal'))();
			default:
				return await sidePanelCardFactory(key);
			}
		} else if (type === 'marker-card-ukazka') {
			return await markerCardFactory(key, extra);
		} else if (type === 'color-picker') {
			return new (await lazyLoadComponent('Modal', 'MarkerColorPicker'))({markerId: key});
		}
	}

	async setModalContent(contentType, contentKey, extra) {
		// in case of opening new modal while old still opened
		// for example clicking "open-other" link in modal content
		if (this.currentContent !== null) {
			this.removeModalContent();
		}

		this.currentContent = await this.contentFactory(contentType, contentKey, extra);
		this.currentContent.mount(this.modal.getComponent());
	}

	removeModalContent() {
		this.currentContent.unmount();
		this.currentContent = null;
	}
}

export default ModalContentManager;
